<template>
    <div>
        <!-- Banner de consentimiento de cookies -->
        <div v-if="showBanner" class="cookie-banner">
            <div class="cookie-content">
                <p>{{ displayCookieMessage }}</p>
                <div class="cookie-buttons">
                    <button @click="acceptCookies" class="btn-accept">
                        {{ displayAcceptText }}
                    </button>
                    <button @click="rejectCookies" class="btn-reject">
                        {{ displayRejectText }}
                    </button>
                    <button @click="showPolicyModal = true" class="btn-more-info">
                        {{ displayMoreInfoText }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal de política de cookies -->
        <div v-if="showPolicyModal" class="cookie-modal-overlay" @click.self="showPolicyModal = false">
            <div class="cookie-modal">
                <div class="cookie-modal-header">
                    <h3>{{ displayCookiePolicyTitle }}</h3>
                    <button class="close-modal" @click="showPolicyModal = false">×</button>
                </div>
                <div class="cookie-modal-content">
                    <div v-html="displayCookiePolicyContent"></div>
                </div>
                <div class="cookie-modal-footer">
                    <button @click="acceptCookies" class="btn-accept">
                        {{ displayAcceptText }}
                    </button>
                    <button @click="rejectCookies" class="btn-reject">
                        {{ displayRejectText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useConfig } from '../composables/useConfig';
import { useLanguage } from '../composables/useLanguage';

export default {
    name: 'CookieConsent',
    data() {
        return {
            showBanner: false,
            showPolicyModal: false,
            cookieAccepted: false,
        }
    },
    setup() {
        const { getConfigText } = useConfig();
        const { language } = useLanguage();
        return {
            getConfigText,
            language
        }
    },
    mounted() {
        // Verificar si el usuario ya aceptó las cookies
        const cookieConsent = localStorage.getItem('cookie-consent')
        if (!cookieConsent) {
            this.showBanner = true
        } else {
            this.cookieAccepted = cookieConsent === 'accepted'
        }
    },
    computed: {
        displayCookieMessage() {
            return this.getConfigText('cookies.bannerMessage', 'Este sitio utiliza cookies para mejorar la experiencia del usuario. Al continuar navegando aceptas nuestra política de cookies.')
        },
        displayAcceptText() {
            return this.getConfigText('cookies.acceptText', 'Aceptar')
        },
        displayRejectText() {
            return this.getConfigText('cookies.rejectText', 'Rechazar')
        },
        displayMoreInfoText() {
            return this.getConfigText('cookies.moreInfoText', 'Más información')
        },
        displayCookiePolicyTitle() {
            return this.getConfigText('cookies.policyTitle', 'Política de Cookies')
        },
        displayCookiePolicyContent() {
            return this.getConfigText('cookies.policyContent', `
                <h4>¿Qué son las cookies?</h4>
                <p>Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Las cookies se utilizan para hacer que los sitios web funcionen, sean más seguros y ofrezcan una mejor experiencia de usuario.</p>
                
                <h4>Cookies necesarias</h4>
                <p>Estas cookies son esenciales para que pueda utilizar las funciones básicas del sitio web. Sin estas cookies, no podemos proporcionar servicios que haya solicitado.</p>
                
                <h4>Cookies analíticas</h4>
                <p>Utilizamos cookies analíticas para entender cómo interactúan los visitantes con el sitio web. Estas cookies nos ayudan a mejorar la experiencia del usuario proporcionando información sobre métricas como el número de visitantes y las páginas más populares.</p>
                
                <h4>Cookies funcionales</h4>
                <p>Estas cookies permiten que el sitio web proporcione una funcionalidad mejorada y personalización. Pueden ser establecidas por nosotros o por proveedores externos cuyos servicios hemos añadido a nuestras páginas.</p>
                
                <h4>Gestión de cookies</h4>
                <p>Puede configurar su navegador para rechazar todas las cookies o para indicar cuándo se está enviando una cookie. Sin embargo, algunas funciones del sitio web pueden no funcionar correctamente sin cookies. Para más información, consulte la documentación de su navegador.</p>
            `)
        }
    },
    methods: {
        acceptCookies() {
            localStorage.setItem('cookie-consent', 'accepted')
            this.cookieAccepted = true
            this.showBanner = false
            this.showPolicyModal = false
            this.$emit('consent-updated', 'accepted')
        },
        rejectCookies() {
            localStorage.setItem('cookie-consent', 'rejected')
            this.cookieAccepted = false
            this.showBanner = false
            this.showPolicyModal = false
            this.$emit('consent-updated', 'rejected')
        },
        openPolicyModal() {
            this.showPolicyModal = true
        },

    }
}
</script>

<style scoped>
.cookie-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.85);
    color: white;
    z-index: 1000;
    padding: 15px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
}

.cookie-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.cookie-content p {
    margin-bottom: 15px;
    font-size: var(--form-font-size);
}

.cookie-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}

.cookie-buttons button {
    padding: 8px 15px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    font-size: var(--form-font-size);
    border: none;
}

.btn-accept {
    background-color: #4CAF50;
    color: white;
}

.btn-reject {
    background-color: #f44336;
    color: white;
}

.btn-more-info {
    background-color: transparent;
    border: 1px solid white !important;
    color: white;
}

/* Modal styles */
.cookie-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
}

.cookie-modal {
    background-color: white;
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.cookie-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--card-padding) var(--container-padding);
    border-bottom: 1px solid #eee;
}

.cookie-modal-header h3 {
    margin: 0;
    font-size: var(--heading-font-size-h3);
}

.close-modal {
    background: none;
    border: none;
    font-size: var(--heading-font-size-h2);
    cursor: pointer;
    color: #555;
}

.cookie-modal-content {
    padding: var(--container-padding);
}

.cookie-modal-content h4 {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: var(--heading-font-size-h4);
}

.cookie-modal-footer {
    padding: var(--card-padding) var(--container-padding);
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.cookie-modal-footer button {
    padding: 8px 15px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    border: none;
}

@media (max-width: 600px) {
    .cookie-buttons {
        flex-direction: column;
        width: 100%;
    }

    .cookie-buttons button {
        width: 100%;
        margin-bottom: 8px;
    }

    .cookie-modal-footer {
        flex-direction: column;
    }

    .cookie-modal-footer button {
        width: 100%;
        margin-bottom: 8px;
    }
}
</style>
